import { Note } from "types/notes";

export const convertArrayToObject = (notesArray: Note[]): Record<string, number> =>
  notesArray.reduce((accumulator, note, index) => {
    accumulator[note.id] = notesArray.length - index;
    return accumulator;
  }, {} as Record<string, number>);
